export default "__VITE_ASSET__Cfr3wWJF__"